<script>
export default {}
</script>

<template>
  <header
    class="flex items-center bg-white md:h-24 md:border-b md:border-gray-200"
  >
    <div class="container container-page mx-auto px-6 mt-3 md:mt-0">
      <nav class="flex flex-col items-center md:flex-row md:justify-between">
        <BaseLink :to="{ name: 'property-landing', query: $route.query }">
          <img
            src="/images/main-logo.png"
            alt="kamandalu-ubud"
            width="100"
            height="63"
          />
        </BaseLink>

        <slot />
      </nav>
    </div>
  </header>
</template>
